import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { def, getFirstItem } from 'lib/util'
import internal from 'model/organisation/collection/internal'

/**
 * Special username styles
 *
 * @param {Object} theme
 * @returns {{verified: {color}, invited: {color}}}
 */
const styles = theme => ({
  root: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  verified: {
    color: theme.palette.info.main,
  },
  invited: {
    color: theme.palette.signal.main,
  },
  subRow: {
    gap: '5px',
    display: 'flex',
    alignItems: 'center',
  },
})

/**
 * Intended to display additional information about the organisation. Is only visible if the user
 * in question passes the acl check.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellOrganisationInfo = (classes, props = {}) => {
  const {
    acl,
    toBeValidated,
    toBeApprovedInfo,
    toBeValidatedInfo,
    parent: {
      key: parentId = null,
      trees: {
        parent: parentsIds = [],
      } = {},
    } = {},
  } = props

  const ids = [parentId, ...parentsIds]

  const displayApproval = internal.some(x => ids.includes(x.key))
  const displayValidation = def(toBeValidated)

  const organisationInfo = (acl !== false && displayValidation && <>{toBeValidatedInfo}</>)
    || (acl !== false && displayApproval && <>{toBeApprovedInfo}</>)
    || '-'

  return <>
    <Typography
      variant={'body2'}
      className={classes.row}
      sx={{
        color: theme => (
          acl !== false && (displayValidation || displayApproval) ? theme.palette.signal.main
            : 'inherit'
        ),
        fontWeight: 700,
      }}
    >
      {organisationInfo}
    </Typography>
  </>
}

export default CellHOC(ListItemCellOrganisationInfo, styles)
